import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;

    .ant-table table tr.resolved {
        background-color: #eeffee;
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const ButtonContainer = styled.div`
    flex-direction: row;
    display: flex;
`;
